import type { BannerTemplateProps } from '../components/BannerTemplate/BannerTemplate';
import type { ResolvedBanner } from '../types/shared';

/**
 * Page props shapes that can carry a resolved banner. Post/page routes nest it
 * under `post`; term (category/tag/author) routes under `term`.
 */
type BannerPageProps = {
    post?: { id?: string; banner?: ResolvedBanner | null };
    term?: { id?: string; banner?: ResolvedBanner | null };
    siteSlug?: string;
    preview?: boolean;
};

/**
 * Pull the banner and its analytics context out of page props for `_app`, which
 * sees every route and therefore several prop shapes.
 *
 * Dismissal is not persisted in preview, where remembering a dismissal would
 * hide the content an author is trying to review.
 */
export function resolveBannerProps(
    pageProps: BannerPageProps | undefined
): BannerTemplateProps {
    const content = pageProps?.post ?? pageProps?.term;

    return {
        banner: content?.banner ?? null,
        surface: pageProps?.siteSlug,
        contentId: content?.id,
        persistDismissal: !pageProps?.preview,
    };
}
